import React, { useContext, useState } from "react";
import Layout from "../../components/layout/Layout";
import { Field, Form, Formik } from "formik";
import { CloseSquare, SearchNormal1 } from "iconsax-react";
import { Dialog } from "@mui/material";
import { MdFileDownload } from "react-icons/md";
import usePlanLogic from "./usePlanLogic";
import { toast } from "react-toastify";
import { ServiceContext } from "../../hooks/context/ServiceContext";

function Plans() {
  const [showAddUserCard, setShowAddUserCard] = useState(false);

  function toggleUserCardModal() {
    setShowAddUserCard((prev) => !prev);
  }
  const { planList, handleSearchTerm, handleDelete, handleDownload } =
    usePlanLogic();

  return (
    <Layout pageName="Plans">
      <section>
        <AddUserCard open={showAddUserCard} handleClose={toggleUserCardModal} />
        <div className=" flex justify-between items-center mt-8">
          <button
            className="btn bg-[#071839] text-white px-12"
            onClick={toggleUserCardModal}
          >
            Create Plan
          </button>
        </div>

        <div className="bg-white rounded-md p-3 mt-3">
          <div className="card  bg-white  rounded ">
            <div className="flex items-center justify-between">
              <h4 className="text-sm">Manage Plans</h4>
              <div className="flex items-center lg:min-w-96 p-2 border-red-400">
                <label className="w-full input input-sm input-bordered flex items-center gap-2 mr-3 pr-0">
                  <input
                    type="text"
                    className="grow w-full"
                    placeholder="Search by name, email, role"
                    onChange={handleSearchTerm}
                  />
                  <div className="bg-[#3D51A3] rounded-md p-2">
                    <SearchNormal1 size="16" color="white" />
                  </div>
                </label>

                <button
                  className="btn btn-sm btn-outline"
                  onClick={handleDownload}
                >
                  <MdFileDownload />{" "}
                </button>
              </div>
            </div>
          </div>

          <div className=" mt-4 bg-white rounded-lg">
            <table className="table min-h-[200px]">
              <thead className="bg-[#F5F5F5]  ">
                <tr>
                  <th className="text-xs">No</th>
                  <th className="text-xs">Plan ID</th>
                  <th className="text-xs">Service</th>
                  <th className="text-xs">Cost(₦)</th>
                  <th className="text-xs">Frequency</th>
                  <th className="text-xs">Type</th>
                  <th className="text-xs">Date Created</th>
                  <th className="text-xs">Actions</th>
                  {/* <th className="text-xs">Last Updated By </th>
                  <th className="text-xs">Last Update On</th> */}
                </tr>
              </thead>
              <tbody className="font-xs font-normal">
                {planList.data?.map((plan, index) => (
                  <tr key={plan.id} className="font-xs font-normal">
                    <th>{index + 1} </th>
                    <th className="font-xs font-normal">{plan.product_id}</th>
                    <th className="font-xs font-normal">{plan.service_name}</th>
                    <th className="text-xs font-normal">{plan.price}</th>
                    <th className="text-xs font-normal">{plan.frequency}</th>
                    <th className="text-xs font-normal">{plan.type}</th>
                    <th className="text-xs font-normal">{plan.createdAt}</th>
                    <th className="text-xs font-normal">
                      <button
                        className="btn btn-outline bg-red-600 btn-xs text-white"
                        onClick={() => handleDelete(plan.id, plan.service_name)}
                      >
                        Delete
                      </button>
                    </th>
                  </tr>
                ))}
              </tbody>
              {planList.isLoading && (
                <div className="  loading loading-spinner"></div>
              )}
            </table>
          </div>
        </div>
      </section>
    </Layout>
  );
}

export default Plans;
type AddCardUser = {
  open: boolean;
  handleClose: () => any;
};
function AddUserCard(props: AddCardUser) {
  const { createPlan, planList } = usePlanLogic();
  const { service } = useContext(ServiceContext);
  // console.log({ service });
  const initialValues: CreatePlanPayload = {
    days: 12,
    frequency: "daily",
    keyword: "",
    network: service as "mtn" | "glo",
    price: 0,
    product_id: "",
    service_id: "",
    service_name: "",
    type: "once",
  };

  return (
    <Dialog open={props.open} onClose={props.handleClose}>
      <div className="p-6 w-[500px]">
        <div className=" w-full mb-4 flex items-center justify-between">
          <p className="font-bold text-sm">Create Plan</p>
          <button onClick={props.handleClose}>
            <CloseSquare size="22" color="#071839" />
          </button>
        </div>

        <Formik
          initialValues={initialValues}
          onSubmit={(values, { setSubmitting }) => {
            setSubmitting(true);
            createPlan.mutate(values, {
              onSuccess: (planResponse) => {
                toast.dismiss();
                toast.success(` ${planResponse.message}`);
                planList.refetch();
                props.handleClose();
              },
              onError: () => {
                toast.dismiss();
                toast.error(`An Error occured while creating the plan`);
              },
              onSettled: () => {
                setSubmitting(false);
              },
            });
          }}
        >
          {({ isSubmitting }) => (
            <Form>
              <div className="grid grid-cols-2 gap-2 ">
                <div className="">
                  <label className="form-control w-full max-w-xs">
                    <p className="label text-xs text-[#4E5566] font-semibold">
                      Plan Name:
                    </p>
                    <Field
                      required
                      name="service_name"
                      className="input input-bordered outline-none w-full max-w-xs"
                    />
                  </label>
                </div>
                <div className="">
                  <label className="form-control w-full max-w-xs">
                    <p className="label text-xs text-[#4E5566] font-semibold">
                      Plan Code
                    </p>
                    <Field
                      required
                      name="product_id"
                      className="input input-bordered outline-none w-full max-w-xs"
                    />
                  </label>
                </div>
                <div className=" mb-3">
                  <label className="form-control w-full max-w-xs">
                    <p className="label text-xs text-[#4E5566] font-semibold">
                      Duration
                    </p>
                    <Field
                      required
                      name="role"
                      as="select"
                      className="input input-bordered select outline-none w-full max-w-xs"
                    >
                      <option value="daily">Daily</option>
                      <option value="weekly">Weekly</option>
                      <option value="monthly">Monthly</option>
                    </Field>
                  </label>
                </div>
                <div className="">
                  <label className="form-control w-full max-w-xs">
                    <p className="label text-xs text-[#4E5566] font-semibold">
                      Amount
                    </p>
                    <Field
                      required
                      name="price"
                      className="input input-bordered outline-none w-full max-w-xs"
                    />
                  </label>
                </div>

                <div className=" mb-3">
                  <label className="form-control w-full max-w-xs">
                    <p className="label text-xs text-[#4E5566] font-semibold">
                      After plan expires
                    </p>
                    <Field
                      required
                      name="type"
                      as="select"
                      className="input input-bordered select outline-none w-full max-w-xs"
                    >
                      <option value="auto">Auto Renew</option>
                      <option value="once">One Time</option>
                    </Field>
                  </label>
                </div>
              </div>
              <div className="mx-6 mt-4">
                <button
                  className="btn btn-outlined w-full bg-[#071839ea] text-white hover:bg-[#071839] "
                  type="submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Saving" : "Save"}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Dialog>
  );
}
